import styled from "styled-components";
import { COLORS } from "../../../constants/Styles";

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${COLORS.obscure};
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;
